
// const serverBaseUrl = 'http://192.168.1.154:8080'
// const serverBaseUrl = 'http://localhost:9000'
const serverBaseUrl = process.env.VUE_APP_BACKEND_API
const miaomiaoxiangServerBaseUrl = process.env.VUE_APP_MIAOMIAOXIANG_BACKEND_API
export const setting = {

    authBaseUrl: `${serverBaseUrl}/auth`,

    adminBaseUrl: `${serverBaseUrl}/admin`,

    resourceBaseUrl: `${serverBaseUrl}/resource`,

    miaomiaoxiangBaseUrl: `${miaomiaoxiangServerBaseUrl}`

}